<template>
  <div class="animated fadeIn">
    <div class="col-sm-12 col-md-12">
      <div class="loading" v-if="processando">
        <div class="progress">
          <div class="progress-bar progress-bar-striped progress-bar-animated bg-success" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div>
        </div>
      </div>

      <div class="modal fade show " id="modalAdicioarCredito" tabindex="-1" role="dialog"
        aria-labelledby="myModalLabel" aria-hidden="true" data-keyboard="false"
        data-backdrop="static" v-if="showModalTratarEvento">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-body">
              <div class="col-md-12">                  
                <div class="row">
                  <div class="form-group col-md-12">
                    <label>Mensagem Evento:</label><br>
                    <input type="text" class="form-control" v-model="tratarEvento.mensagemEventoDisparado">
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-6">
                    <label>Adiar evento até:</label><br>
                    <select class="pula form-control custom" v-model="tratarEvento.adiarEventoDisparado">
                      <option value="" label=""></option>
                      <option value="1h" label="Adiar por 1:00h">Adiar por 1:00h</option>
                      <option value="6h" label="Adiar por 6:00hs">Adiar por 6:00hs</option>
                      <option value="1d" label="Adiar por 01 dia">Adiar por 01 dia</option>
                      <option value="5d" label="Adiar por 05 dias">Adiar por 05 dias</option>
                      <option value="10d" label="Adiar por 10 dias">Adiar por 10 dias</option>
                    </select>
                  </div>
                  <div class="form-group col-md-6">
                    <label>Tratar todos os Eventos:</label><br>
                    <select class="pula form-control custom" v-model="tratarEvento.tratarTodosEventos">
                      <option value="true" label="Sim">Sim</option>
                      <option value="false" label="Não">Não</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-success" v-on:click="gravarTratarEvento">Gravar</button>
              <button type="button" class="btn btn-danger" v-on:click="showModalTratarEvento = false">Fechar</button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade show " id="modalAdicioarCredito" tabindex="-1" role="dialog"
        aria-labelledby="myModalLabel" aria-hidden="true" data-keyboard="false"
        data-backdrop="static" v-if="showModalMapa">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-body">
              <div class="col-md-12">                  
                <div class="row">
                  <gmap-map
                    :center="center"
                    :zoom="4"
                    ref="map"
                    style="width:calc(100vw - 58px);  height: calc(100vh - 58px)"
                  >
                    <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen=false">
                      <span v-html="infoContent"></span>
                    </gmap-info-window>
                    <gmap-marker
                      :key="index"
                      v-for="(m, index) in markers"
                      :position="m.position"
                      @click="toggleInfoWindow(m,index)"
                    ></gmap-marker>
                    <gmap-polyline v-if="path.length > 0" :path="path" :editable="false"
                        ref="polyline">
                    </gmap-polyline>
                  </gmap-map>  
                  
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal" v-on:click="showModalMapa = false">Fechar</button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade show " id="modalAdicioarCredito" tabindex="-1" role="dialog"
        aria-labelledby="myModalLabel" aria-hidden="true" data-keyboard="false"
        data-backdrop="static" v-if="showModalRelatorio">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">Relatório de Eventos Disparados</h4>
            </div> 
            <div class="modal-body">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-6">
                    <label>Data Inicial:</label><br>
                    <input-data-picker v-model="relatorio.dataInicial" name="data" v-validate="'required'" data-vv-delay="500" :class="{'input pula form-control data': true, 'is-danger': errors.has('data') }" />
                  </div>
                  <div class="col-md-6">
                    <label>Data Final:</label><br>
                    <input-data-picker v-model="relatorio.dataFinal" name="data" v-validate="'required'" data-vv-delay="500" :class="{'input pula form-control data': true, 'is-danger': errors.has('data') }" />
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-sm-12 col-md-12">
                    <label>Veículo:</label><br>
                    <input id="motoristaId" type="hidden" class="form-control" v-model="relatorio.motoristaId">
                    
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-success" data-dismiss="modal" v-on:click="gerarRelatorio">Gerar</button>
              <button type="button" class="btn btn-danger" data-dismiss="modal" v-on:click="showModalRelatorio = false">Fechar</button>
            </div>
          </div>
        </div>
      </div>
      
      <div class="card">
        <div class="card-body">
          <div id="titulo" class="panel panel-default">
            <!-- Default panel contents -->
            <div class="panel-body">
              <div class="row row-margin">
                <div class="col-md-12">
                  <h4>Eventos Disparados</h4>
                </div>
              </div>
              <div class="row row-margin">
                <div class="col-md-12">
                  
                  <button type="button" class="btn btn-primary" v-on:click="tratarEventoModal"> 
                    <span class="glyphicon glyphicon-plus"></span> Tratar Evento
                  </button>
                  <button type="button" class="btn btn-primary" v-on:click="showModalRelatorio = true"> 
                    <span class="glyphicon glyphicon-plus"></span> Relatório
                  </button>
                  <span id="imprimirLinks"> </span>
                </div>
              </div>
            </div>
          </div>

          <div id="filtros" class="panel panel-default">
            <!-- Default panel contents -->
            <div class="panel-body">
              <div class="row row-margin">
                <div class="col-sm-1 col-md-1">
                  <div class="form-group">
										<label class="label-filtros">Periodo:</label>
										<input-data-picker class="pula data form-control" v-model="filtros.dataInicial" />
									</div>
								</div>
								<div class="col-md-1">
									<div class="form-group">
										<label class="label-filtros">&nbsp;</label>
										<input-data-picker class="pula data form-control" v-model="filtros.dataFinal" />
									</div>
								</div>
								<div class="col-sm-4 col-md-4">
									<div class="form-group has-feedback">
										<label class="label-filtros">Veiculo:</label><br>
										<input class="form-control hasclear" type="text" v-model="filtros.buscas" v-on:keyup.enter="buscar()" />
										<span id="limparbusca" class="glyphicon glyphicon-remove-circle"></span>
									</div>
								</div>
								
								<div class="col-sm-3 col-md-3">
									<div class="form-group">
										<label class="label-filtros">Evento:</label>
										<select class="pula form-control custom" v-model="filtros.eventoId" >
                      <option value="0" selected="selected">Todos</option>
                      <option v-for="evento in eventos" v-bind:value="evento.id">{{evento.nome}}</option>
										</select>
									</div>
								</div>
                <div class="col-sm-2 col-md-2">
                  <div class="form-group">
                    <label class="label-filtros">Tratados:</label>
                    <select class="form-control custom" v-model="filtros.status">
                      <option value="T" label="Todos">Todos</option>
                      <option value="L" label="Apenas Tratados">Apenas Tratados</option>
                      <option value="NL" label="Apenas Não Tratados">Apenas Não Tratados</option>
                    </select>
                  </div>
                </div>
								<div class="col-md-1">
									<div class="form-group">
										<label class="label-filtros">&nbsp;</label><br>
										<input class="btn btn-success" type="button" v-on:click="buscar()" value="Buscar">
									</div>
								</div>
							</div>
						</div>
					</div>
          <div class="row">
            <div class="col-sm-12 col-md-12">
              <div id="dados-limpo">
                <input id="idsSelecionados" type="hidden"/>
                <table id="tabelaVeiculos"
                class="table table-responsive-sm table-hover table-outline mb-0"
                width="100%" style="overflow-x: auto;">
                <thead class="thead-light">
                  <tr>
                    <th>Data</th>
                    <th>Veículo</th>
                    <th>Evento</th>
                    <th>Ponto</th>
                    <th>Tratado</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="eventoDisparado in dadosTabela" :class="{ 'selecionado': selecionado(eventoDisparado) }" @click="selecionarItem(eventoDisparado, $event)" >
                    <td width="100">{{eventoDisparado.dataHoraEvento}}</td>
                    <td width="230">
                      <strong>{{eventoDisparado.veiculoDescricao}}</strong>
                    </td>
                    <td width="300">{{eventoDisparado.eventoNome}}</td>
                    <td>
                      <template v-if="eventoDisparado.latitude !== 0 && eventoDisparado.latitude !== null">
                        <img src="/static/images/ponto.png" />
                      </template>
                      {{eventoDisparado.pontoDescricao}}
                    </td>
                    <td class="text-center">
                      <template v-if="eventoDisparado.lido === true">
                        <img v-tooltip="eventoDisparado.lidoUsuarioNome + '<br>' + eventoDisparado.dataHoraEventoLido" src="/static/images/true.png" /> 
                      </template>
                      <template v-else>
                        <img src="/static/images/false.png" />
                      </template>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>

</template>
<script>
import vuePages from 'vue-pages'
import axios from 'axios'
import Blob from 'blobjs'
export default {
  data () {
    return {
      filtros: {
        dataInicial: this.dataAtual(),
        dataFinal: this.dataAtual(),
        buscas: this.$store.state.filtrosEventoDisparado.buscas,
        eventoId: this.$store.state.filtrosEventoDisparado.eventoId,
        status: this.$store.state.filtrosEventoDisparado.status
      },
      tratarEvento: {
        mensagemEventoDisparado: 'Evento visualizado',
        adiarEventoDisparado: '',
        tratarTodosEventos: true
      },
      relatorio: {
        dataInicial: this.primeiroDiaMes(''),
        dataFinal: this.ultimoDiaMes(''),
        veiculoId: '0',
        veiculoNome: ''
      },
      dadosTabela: [],
      selecionada: '',
      selecionados: [],
      eventos: [],
      processando: false,
      showModalRelatorio: false,
      showModalMapa: false,
      showModalTratarEvento: false,
      center: { lat: -17.7455301, lng: -60.6698182 },
      infoContent: '',
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      markers: [],
      path: []
    }
  },
  created: function () {
    this.buscar()
    this.buscarEventos()
  },
  components: {
    vuePages
  },
  mounted: function () {
    $('.pula').keypress(function (e) {
      var tecla = (e.keyCode ? e.keyCode : e.which)
      if (tecla === 13) {
        let campo = $('.pula')
        let indice = campo.index(this)
        if (this.className.includes('adicionar')) {
          $('#adicionar').focus()
        }
        if (campo[indice + 1] != null) {
          let proximo = campo[indice + 1]
          proximo.focus()
        }
        e.preventDefault(e)
        return false
      }
    })
  },
  methods: {
    selecionarItem: function (item, event) {
      this.selecionada = item.id
      if (event.ctrlKey || event.metaKey) {
        if (this.selecionados.includes(item)) {
          let p = this.selecionados.indexOf(item)
          this.selecionados.splice(p, 1)
        } else {
          this.selecionados.push(item)
        }
      } else {
        if (this.selecionados.includes(item)) {
          let p = this.selecionados.indexOf(item)
          this.selecionados.splice(p, 1)
        } else {
          this.selecionados = []
          this.selecionados.push(item)
        }
      }
    },
    selecionado: function (item) {
      return this.selecionados.includes(item)
    },
    paginacao (d, e) {
      this.pagina = d
      this.buscar(this.pagina)
    },
    buscar: function () {
      var self = this
      this.$store.commit('SET_FILTROS_EVENTO_DISPARADO', self.filtros)
      var dadosCadastro
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      self.processando = true
      var url = '/api/eventosDisparados?buscas=' + this.filtros.buscas + '&dataInicial=' + this.filtros.dataInicial + '&dataFinal=' + this.filtros.dataFinal + '&eventoId=' + this.filtros.eventoId + '&status=' + this.filtros.status
      axios.get(url, config)
      .then(function (response) {
        dadosCadastro = response.data
        self.dadosTabela = dadosCadastro.dados
        self.processando = false
      })
    },
    buscarEventos: function () {
      var self = this
      var dadosCadastro
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/buscarEventosAtivos?busca='
      axios.get(url, config)
      .then(function (response) {
        dadosCadastro = response.data
        self.eventos = dadosCadastro
      })
    },
    setarVeiculo: function (veiculo) {
      this.relatorio.veiculoId = veiculo.idVeiculo
      this.relatorio.veiculoDescricao = veiculo.descricaoVeiculo
      $(this.$el).find('#veiculoDescricao').val(veiculo.descricaoVeiculo)
    },
    verificarVeiculo: function () {
      if ($(this.$el).find('#veiculoId').val() === '0') {
        this.relatorio.veiculoId = 0
        this.relatorio.veiculoDescricao = ''
        $(this.$el).find('#veiculoId').val(0)
        $(this.$el).find('#veiculoDescricao').val('')
      }
      if ($(this.$el).find('#veiculoDescricao').val() === '') {
        this.relatorio.veiculoId = 0
        this.relatorio.veiculoDescricao = ''
        $(this.$el).find('#veiculoId').val(0)
        $(this.$el).find('#veiculoDescricao').val('')
      }
    },
    tratarEventoModal: function () {
      let self = this
      if (self.selecionados.length < 1) {
        self.$toastr('error', 'Selecione um evento para tratar.', 'Atenção')
        return
      }
      self.showModalTratarEvento = true
    },
    gravarTratarEvento: function () {
      let self = this
      if (self.selecionados.length < 1) {
        self.$toastr('error', 'Selecione um evento para tratar.', 'Atenção')
        return
      }
      self.processando = true
      var config = {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.$store.state.token
        }
      }
      let sel = ''
      for (let i = 0; i < self.selecionados.length; i++) {
        if (i === 0) {
          sel = self.selecionados[i].id
        } else {
          sel = sel + ';' + self.selecionados[i].id
        }
      }
      var url = '/api/tratarEventoDisparado?id=' + sel + '&mensagemEventoDisparado=' + self.tratarEvento.mensagemEventoDisparado + '&adiarEventoDisparado=' + self.tratarEvento.adiarEventoDisparado + '&tratarTodosEventos=' + self.tratarEvento.tratarTodosEventos
      axios.get(url, config)
      .then(function (response) {
        self.showModalTratarEvento = false
        self.processando = false
        if (response.data === 'OK') {
          self.$toastr('success', 'Evento tratado com sucesso.', 'Atenção')
          self.buscar()
          self.tratarEvento.mensagemEventoDisparado = 'Evento visualizado'
          self.tratarEvento.adiarEventoDisparado = ''
          self.tratarEvento.tratarTodosEventos = true
        } else {
          self.$toastr('error', 'Erro ao tratar Evento.', 'Atenção')
        }
      })
      .catch(function (error) {
        console.log(error)
      })
    },
    imprimir: function (id) {
      // Imprimir
      let self = this
      self.processando = true
      var config = {
        headers: {
          'Content-Type': 'application/pdf',
          'Authorization': 'Bearer ' + this.$store.state.token
        },
        responseType: 'blob'
      }
      var url = '/api/gestaoJornadas/imprimirJornadaAnalitica?id=' + id + '&semMovimento=0'
      axios.get(url, config)
      .then(function (response) {
        const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}))
        const link = document.createElement('a')
        link.href = url
        // link.setAttribute('filename', 'file.pdf')
        link.setAttribute('target', '_blank')
        document.getElementById('imprimirLinks').appendChild(link)
        link.click()
        self.processando = false
      }).catch(function (error) {
        console.log(error)
        self.processando = false
      })
    },
    gerarRelatorio: function (e) {
      // Imprimir
      let self = this
      self.isLoadingVisualizar = true
      var config = {
        headers: {
          'Content-Type': 'application/pdf',
          'Authorization': 'Bearer ' + this.$store.state.token
        },
        responseType: 'blob'
      }
      var url = '/api/gestaoJornadas/imprimirJornadaSintetica?dataHoraInicio=' + this.relatorio.dataInicial + ' 00:00:00&dataHoraFinal=' + this.relatorio.dataFinal + ' 23:59:59&motoristaId=' + this.relatorio.motoristaId
      axios.get(url, config)
      .then(function (response) {
        const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}))
        const link = document.createElement('a')
        link.href = url
        // link.setAttribute('filename', 'file.pdf')
        link.setAttribute('target', '_blank')
        document.getElementById('imprimirLinks').appendChild(link)
        link.click()
        self.isLoadingVisualizar = false
      }).catch(function (error) {
        console.log(error)
        self.processando = false
      })
    },
    gerarNovaJornada: function (e) {
      // Imprimir
      let self = this
      self.isLoadingVisualizar = true
      var config = {
        headers: {
          'Content-Type': 'application/pdf',
          'Authorization': 'Bearer ' + this.$store.state.token
        },
        responseType: 'blob'
      }
      var url = '/api/gestaoJornadas/novo?dataHoraInicio=' + this.jornada.dataHoraInicial + '&dataHoraFinal=' + this.jornada.dataHoraFinal + '&veiculoId=' + this.jornada.veiculoId + '&motoristaId=' + this.jornada.motoristaId + '&tipoJornada=' + this.jornada.tipoJornada
      axios.get(url, config)
      .then(function (response) {
        // link.setAttribute('filename', 'file.pdf')
        self.isLoadingVisualizar = false
        self.showModalNovaJornada = false
        self.buscar()
      }).catch(function (error) {
        console.log(error)
        self.processando = false
      })
    },
    deletar: function (id) {
      let self = this
      let message = 'Deseja realmente deletar essa Jornada?'
      let options = {
        html: false, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
        loader: true, // set to true if you want the dailog to show a loader after click on "proceed"
        reverse: false, // switch the button positions (left to right, and vise versa)
        okText: 'Sim',
        cancelText: 'Não',
        animation: 'zoom', // Available: "zoom", "bounce", "fade"
        type: 'basic', // coming soon: 'soft', 'hard'
        verification: 'continue', // for hard confirm, user will be prompted to type this to enable the proceed button
        clicksCount: 3 // for soft confirm, user will be asked to click on "proceed" btn 3 times before actually proceeding
      }
      this.$dialog.confirm(message, options)
      .then((dialog) => {
        setTimeout(() => {
          var config = {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + this.$store.state.token
            }
          }
          self.loading = true
          var url = '/api/gestaoJornadas/deletar?id=' + id
          axios.get(url, config)
          .then(function (response) {
            console.log(response)
            if (response.data === 'OK') {
              self.$toastr('success', 'Jornada deletada com sucesso.', 'Atenção')
              self.buscar()
              dialog.close()
            } else {
              self.$toastr('error', 'Essa Jornada está em USO e não pode ser deletado.', 'Atenção')
              dialog.close()
            }
          })
          .catch(function (error) {
            console.log(error)
          })
        }, 2500)
      })
      .catch(function () {
        console.log('Clicked on cancel')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/eventosdisparados/EventosDisparadosLista.vue